import moment from "moment";
import { DepositFilters } from "../../../store/reports/reportSelectors";
import CommonDatePicker from "./shared-components/CommonDatePicker";
import { TbCaretUpDownFilled } from "react-icons/tb";
import { useState } from "react";
import { useAppSelector } from "@hypexone/uicore";

type Filters = {
  dateFrom: any;
  dateTo: any;
  pageToken: string[];
  status: string;
};
interface DepositTurnoverFilterProps {
  onDateChange: Function;
  filters: Filters;
  setFilters: Function;
  onSubmit: Function;
  fields: any;
  setTransactionType: any;
  TransactionType: any;
}
const DepositTurnoverFilter: React.FC<DepositTurnoverFilterProps> = ({
  fields,
  onSubmit,
  setTransactionType,
  TransactionType,
  // buttonLabel = "Submit",
  onDateChange,
  filters,
  setFilters,
}) => {
  const [newFromDateChange, setNewFromDateChange] = useState<Date>(
    filters.dateFrom
  );
  const [newToDateChange, setNewToDateChange] = useState<Date>(filters.dateTo);

  const handleFromDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newFromDate = new Date(event.target.value);
    setNewFromDateChange(newFromDate);
  };

  const handleToDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newToDate = new Date(event.target.value);
    setNewToDateChange(newToDate);
  };

  const handleTransactionType = (event) => {
    if (event.target.value !== "All") {
      setTransactionType(event.target.value);
    } else {
      setTransactionType("");
    }
  };
  const {langData} = useAppSelector((state) => state.cms);
  const handleDateChange = (newFromDate: Date, newToDate: Date) => {
    setFilters({
      ...filters,
      startDate: moment(newFromDate),
      endDate: moment(newToDate),
    });
  };
  const handleSubmit = () => {
    const updatedFromDate = moment(newFromDateChange).add(1, "days");
    onDateChange(updatedFromDate, newToDateChange);
    setFilters({
      ...filters,
      dateFrom: moment(updatedFromDate),
      dateTo: moment(newToDateChange),
      status: TransactionType,
    });
  };

  return (
     <div className="flex mb-2  flex-col bg-white p-2 border-t border-b border-black   w-full lg:flex-row lg:space-x-2 lg:items-center ">
      <div className="w-full  flex flex-col lg:flex-row lg:items-center lg:space-x-2 gap-2 md:gap-3">
        <CommonDatePicker
           InOnChange={handleToDateChange}
          InValue={new Date(newToDateChange).toISOString().split("T")[0]}
          FromValue={new Date(newFromDateChange).toISOString().split("T")[0]}
          FromOnChange={handleFromDateChange}
        />
        <div className="w-full flex gap-3" >
        <div className="relative w-[100%] mt-1 sm:mt-0">
          <label
            htmlFor="transactionType"
            className="block  text-gray-700 font-helvetica text-xs"
          >
            TRANSACTION
          </label>
          <select
            id="transactionType"
            className="border h-9  w-full rounded p-1 border-gray-400 shadow-sm appearance-none pr-10 "
            value={TransactionType}
            onChange={(e) => handleTransactionType(e)}
          >
            {DepositFilters.map((type) => (
              <option key={type.value} value={langData?.[`${type.value}`]}>
                {langData?.[`${type.name}`]}
              </option>
            ))}
          </select>
        </div>

        <div className=" sm:mt-0 w-[100%]" onClick={handleSubmit}>
          <div className="flex text-[14px] w-full py-[7px] h-9 mt-4 rounded-[4px] cursor-pointer bg-black1 text-white  items-center justify-center">
            Get Turnover
          </div>
        </div>
        </div>
      </div>
    </div>
  );
};

export default DepositTurnoverFilter;
